import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useUpdate } from "@/hooks/queries";
import { getAssetConditionRatingFieldValue } from "@/modules/asset/asset-condition-rating-field";
import { getAssetRiskFieldValue } from "@/modules/asset/asset-risk-field";
import { getParentAssetSelectOptionValue } from "@/modules/assets/assets-select-parent";
import { getLocationSelectOptionValue } from "@/modules/location/location-select-parent";
import { parseDate, daysToRoundedYears } from "@/utilities/date";

import AssetForm from "../AssetForm";

const invalidateKeys = [
  ["locations", "coordinates"],
  ["datasets"],
  ["tree", "locations"],
];

const AssetEdit = ({ model }) => {
  const { t } = useTranslation();

  const mutation = useUpdate("assets", model.id, { invalidateKeys });

  const initialValues = {
    location: getLocationSelectOptionValue(model.ancestors),
    asset: getParentAssetSelectOptionValue(model.ancestors, model.id),
    name: model.name,
    assetType: {
      label: model.asset_type.name,
      value: model.asset_type_id,
      key: model.asset_type_id,
    },
    referenceNumber: model.reference,
    description: model.description,
    manufacturer: model.manufacturer,
    model: model.model,
    serialNumber: model.serial,
    manufactureDate: parseDate(model.date_manufacture) ?? "",
    serviceDate: parseDate(model.date_service) ?? "",
    replacementCost: model.replacement_cost,
    theoreticalLifespan: daysToRoundedYears(model.theoretical_lifespan_in_days),
    assetInfo: model.asset_info,
    technicalInfo: model.technical_info,
    studyFrequency: model.study_frequency_in_month,
    coordinate: model.coordinate,
    severityGrid: {
      label: model.severity_grid?.name ?? "",
      value: model.severity_grid_id,
      key: model.severity_grid_id,
    },
    conditionRating: getAssetConditionRatingFieldValue(model),
    risk: getAssetRiskFieldValue(model),
    cmmsId: model.cmms_id,
    erpId: model.erp_id,
    attendanceToken: model.attendance_token,
    template: model.default_template,
  };

  return (
    <AssetForm
      model={model}
      mutation={mutation}
      saveButtonLabel={t("global:update")}
      initialValues={initialValues}
    />
  );
};

AssetEdit.propTypes = {
  model: PropTypes.object.isRequired,
};

export default AssetEdit;
